import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { RouterLinkType } from '@core/common.types';
import { navigateNewWindow } from '@platform/shared/utilities/navigate.util';

@Component({
  selector: 'app-link-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './link-button.component.html',
  styles: [],
})
export class LinkButtonComponent implements OnInit {
  @Input() text!: string;
  @Input() icon!: string;
  @Input() disabled!: boolean;
  @Output() clicked = new EventEmitter();
  @Input() link: RouterLinkType;
  @Input() fontSet?: string;
  @Input() openBlank = false;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  public click($event: any): void {
    if (this.disabled) {
      return;
    }

    if (this.link) {
      if (this.openBlank) {
        console.log({ link: this.link });
        const linkAsArray = Array.isArray(this.link) ? this.link : [this.link];
        if (Array.isArray(this.link)) {
          this.router.navigate(this.link);
        } else if (typeof this.link == 'string') {
          this.router.navigateByUrl(this.link);
          navigateNewWindow(this.router, linkAsArray);
          return;
        }
      }
      if (Array.isArray(this.link)) {
        this.router.navigate(this.link);
      } else if (typeof this.link == 'string') {
        this.router.navigateByUrl(this.link);
      } else {
        $event.preventDefault();
        $event.stopPropagation();
        this.clicked.emit();
      }
      return;
    }

    $event.preventDefault();
    $event.stopPropagation();
    this.clicked.emit();
  }
}
